import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../react/components/Button';
import Loader from '../../../../web/images/svg/loader.svg';

import { useRemoveAllPerformancesMutation, useRemoveAllPerformancesSingleCyoMutation } from '../redux/tessituraApiSlice';
import { useAppSelector } from '../hooks';

const ResetSelection = ({
  handleCloseModal, onAccept, packageLineNumber,
}: ResetSelectionProps) => {
  const [removePerformances, {
    error: removePerformancesError,
    isLoading: removePerformancesIsLoading,
    isSuccess: removePerformancesIsSuccess,
  }] = useRemoveAllPerformancesMutation();

  const [removeAllPerformancesSingleCyo, {
    error: removePerformancesSingleCyoError,
    isLoading: removePerformancesSingleCyoIsLoading,
    isSuccess: removePerformancesSingleCyoIsSuccess,
  }] = useRemoveAllPerformancesSingleCyoMutation();

  const { cyoType } = useAppSelector((state) => state.sessionSlice);

  useEffect(() => {
    if (removePerformancesIsSuccess || removePerformancesSingleCyoIsSuccess) handleCloseModal();
  }, [handleCloseModal, removePerformancesIsSuccess, removePerformancesSingleCyoIsSuccess]);

  const handleAccept = async () => {
    try {
      if (packageLineNumber) {
        await removePerformances(packageLineNumber);
      }
      onAccept();
    } catch ({ error }) {
      throw new Error(`Error removing performance: ${error}`);
    }
  };

  const handleAcceptSingleCyo = async () => {
    try {
      await removeAllPerformancesSingleCyo(false);
      onAccept();
    } catch ({ error }) {
      throw new Error(`Error removing performance: ${error}`);
    }
  };

  if (removePerformancesError || removePerformancesSingleCyoError) {
    return <div>Error: Could not remove performances</div>;
  }
  return (
    <div className="c-cyop__modal-buttons">
      <Button
        cyopInverse
        cyopModal
        onClick={handleCloseModal}
        onKeyDown={handleCloseModal}
      >
        Go Back
      </Button>
      <Button
        cyopModal
        disabled={removePerformancesIsLoading || removePerformancesSingleCyoIsLoading}
        onClick={cyoType === 'single-cyo' ? handleAcceptSingleCyo : handleAccept}
        onKeyDown={cyoType === 'single-cyo' ? handleAcceptSingleCyo : handleAccept}
        cyopModalWithLoader={removePerformancesIsLoading || removePerformancesSingleCyoIsLoading}
      >
        I Understand, Confirm
        {(removePerformancesIsLoading || removePerformancesSingleCyoIsLoading) && (
          <div className="c-loader c-loader--button c-loader--dark c-loader--small"><Loader /></div>
        )}
      </Button>
    </div>
  );
};

const resetSelectionPropTypes = {
  handleCloseModal: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  packageLineNumber: PropTypes.number,
};

ResetSelection.defaultProps = {
  packageLineNumber: null,
};

ResetSelection.propTypes = resetSelectionPropTypes;

type ResetSelectionProps = PropTypes.InferProps<typeof resetSelectionPropTypes>;

export default ResetSelection;
